import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { InvestigationModel } from 'app/EMR/DoctorModels/investigation.model';
import { EMRService } from 'app/EMR/EMR.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { InvestigationServicesComponent } from '../investigation-services/investigation-services.component';
import { Observable, of, Subject, interval } from 'rxjs';
import { map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { AuthService } from 'app/auth/auth.service';
import { InvestigationTemplatedataModel, InvestigationTemplateMasterModel } from 'app/EMR/EMRModels/Findingtemplate.model';
import { FormControl } from '@angular/forms';
import { AnonymousSubject } from 'rxjs-compat';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-investigation',
  templateUrl: './investigation.component.html',
  styleUrls: ['./investigation.component.scss']
})
export class InvestigationComponent implements OnInit {
  private destroyinves$: Subject<boolean> = new Subject<boolean>();
  private investigation_ds: MatTableDataSource<InvestigationModel>
  private displayedColumns_investigations: string[] = ['investigation', 'comments', 'site', 'Action'];
  private InvestigationTemplateMasterModel: InvestigationTemplateMasterModel = {};
  private findingTemplateArray: any[] = [];
  private templatedetailData:InvestigationTemplatedataModel[]=[];
  private filteredDoctorArray1: Observable<any[]>;
  private doctorholdData: Observable<any[]>;
  private DoctorCtrl1: FormControl;
  @Input() investigationsModule: any;
  private loadTemplateModalIsOpen: boolean = false;
  isshowSave: boolean = false;
  doctorID: number;
  constructor(private dialogRef: MatDialogRef<InvestigationComponent>,
  @Optional() @Inject(MAT_DIALOG_DATA) private data: any, private dialog: MatDialog, private emrservice: EMRService, private dashboardService: DashboardService, private opdvisitService: OpdVisitService, private authService: AuthService,private datePipe: DatePipe) { }
  surgeryDetailArray: any = [];
  examid: any;
  allcheck: boolean = false;
  showspinner: boolean = false;
  examdetailArray: any = [];
  isheader: boolean = false;
  istransfershow:boolean = true;
  private inhouse_data: any = [];
  rowClickedtemplate: number = -1;
  templatesearch = '';
  ngOnInit(): void {
    this.isAdminUser()
    if (this.data) {
      this.isheader = this.data.isheader;
    } else {
      this.isheader = false;
    }
    this.emrservice.share.pipe(takeUntil(this.destroyinves$)).subscribe((x: any) => {

      if (x == 2) {
        this.examid = this.emrservice.examid;
        this.GetInvestigationDetailByRegId(this.opdvisitService.patientdetails.pkRegId);
        // this.GetFindingGResultByregid(this.opdvisitService.patientdetails.pkRegId);
      }
      if (x == 3) {
        this.examid = this.emrservice.examid;
        //   this.investigation_ds.data = this.surgeryDetailArray.filter(item => item.fK_ExamId == this.emrservice.examid);
        this.GetInvestigationDetailByRegId(this.opdvisitService.patientdetails.pkRegId);
        //  this.opdvisitService.patientDrdetaill = this.opdvisitService.patientDrdetaill.filter(item => item.pK_ExamId == this.emrservice.examid);
      }
      if (x == 22) {
        this.examid = this.emrservice.examid;
      }

    });
    this.emrservice.enabledisablebtnInv = true;
    // this.getSite();

    this.emrservice.transferArray.pipe(takeUntil(this.destroyinves$)).subscribe((item: any) => {
      if (item.length > 0) {
        this.emrservice.enabledisablebtnInv = false;
        item.forEach((element, index) => {
          this.surgeryDetailArray.push({
            "fK_TemplateId": element.fK_TemplateId, 'pK_TranId': 0, 'fK_ExamId': 0, "pK_TempInvDetailId": element.pK_TempInvDetailId, "serviceName": element.serviceName,
            "fK_ServiceId": element.fK_ServiceId, "rate": '0', "Site": '', "Comments": '',
            "DisCount": '0', "isHidden": false, "isEdit": false, 'Academic': false, "isDeleted": 0, 'oldExamId': null
          });
          // 
        });
        this.surgeryDetailArray = this.surgeryDetailArray.reduce((unique, o) => {
          if (!unique.some(obj => obj.serviceName === o.serviceName && obj.fK_ServiceId === o.fK_ServiceId)) {
            unique.push(o);
          }
          return unique;
        }, []);

        const index = this.surgeryDetailArray.filter(list => list.fK_ServiceId == 0);
        if (index.length > 0) {
          this.surgeryDetailArray.splice(index, 1);
        }
        this.investigation_ds = new MatTableDataSource(this.surgeryDetailArray.slice());


      }
    })

    // AI Scribe — pre-fill investigations from a voice consultation
    this.emrservice.aiWorkup$.pipe(takeUntil(this.destroyinves$)).subscribe(() => this.consumeAiInvestigations());
    interval(1500).pipe(takeUntil(this.destroyinves$)).subscribe(() => this.consumeAiInvestigations());

    this.templatedetailData =[]
    this.DoctorCtrl1 = new FormControl();
    this.emrservice.componentClicked$.subscribe(() => {
      if(!this.emrservice.enabledisablebtnInv){
        setTimeout(()=>{ 
          if(this.emrservice.examid>0){
            this.examid = this.emrservice.examid;
            this.SaveInvestigation(true,1);
          }
          }, 400);
       
      }
    });
  }
  ngOnDestroy() {
    this.destroyinves$.next(true);
    this.destroyinves$.unsubscribe();
    this.surgeryDetailArray = null;
    this.examdetailArray = null;
    this.displayedColumns_investigations = null;
    this.inhouse_data = null;
    this.filteredDoctorArray1 = null;
    this.emrservice.transferArray =null;

  }

  /** AI Scribe: pull investigations in, then resolve each name to a service id. */
  consumeAiInvestigations(): void {
    const p = this.emrservice.aiWorkupPending;
    if (!p || !p.investigations || !p.investigations.length) { return; }
    const shown = (this.investigation_ds && this.investigation_ds.data) || [];
    if (shown.some((r: any) => r && r.aiSuggested)) { return; }
    const aiList = p.investigations.slice();
    this.surgeryDetailArray = shown.slice();
    const refresh = () => { this.investigation_ds = new MatTableDataSource(this.surgeryDetailArray.slice()); };

    aiList.forEach((r: any) => {
      const idx = this.surgeryDetailArray.push({
        fK_TemplateId: 0, pK_TranId: 0, fK_ExamId: this.examid, pK_TempInvDetailId: 0,
        serviceName: r.serviceName || '', fK_ServiceId: 0, rate: '0',
        Site: r.eye || '', Comments: r.comments || '', DisCount: '0',
        isHidden: false, isEdit: false, Academic: false, isDeleted: 0, oldExamId: null,
        aiSuggested: true, aiUnmatched: true,
      }) - 1;

      // resolve the service name -> master service id (global search)
      if (r.serviceName) {
        this.emrservice.GetServiceByNameGlobal(r.serviceName, 'S')
          .pipe(takeUntil(this.destroyinves$))
          .subscribe((data: any[]) => {
            const hit = this.matchServiceByName(data || [], r.serviceName);
            if (hit) {
              this.surgeryDetailArray[idx].fK_ServiceId = hit.serviceId;
              this.surgeryDetailArray[idx].serviceName = hit.serviceName;
              this.surgeryDetailArray[idx].rate = hit.rate != null ? ('' + hit.rate) : '0';
              this.surgeryDetailArray[idx].aiUnmatched = false;
              refresh();
            }
          }, () => { /* keep name-only on error */ });
      }
    });
    refresh();
    this.emrservice.enabledisablebtnInv = false;
  }

  /** Per-tab AI fill — applies only this section's slice. */
  aiFillInvestigations(s: any): void { this.emrservice.applyAiWorkup({ investigations: (s && s.investigations) || [] }); }

  /** Best-effort service-name match (exact, then contains). */
  private matchServiceByName(list: any[], name: string): any | null {
    if (!name || !list || !list.length) { return null; }
    const n = ('' + name).toLowerCase().trim();
    let m = list.find((x) => ('' + (x.serviceName || '')).toLowerCase().trim() === n);
    if (!m) { m = list.find((x) => ('' + (x.serviceName || '')).toLowerCase().includes(n) || n.includes(('' + (x.serviceName || '')).toLowerCase())); }
    return m || null;
  }
  // getSite() {
  //   this.emrservice.getMasterSite().subscribe(data => {
  //     this.sitelist =[];
  //     this.sitelist = data;

  //   });
  // }
  // GetFindingGResultByregid(regid) {

  //   this.emrservice.GetFindingGResultByregid(regid,this.opdvisitService.visitid,this.opdvisitService.DoctorIdEmr).subscribe((x: any) => {
  //     this.examdetailArray = [];
  //     this.emrservice.patientEMRdetail = [];
  //     this.emrservice.patientEMRdetail = x;
  //     this.examdetailArray = this.emrservice.patientEMRdetail.filter(item => item.pK_ExamId == this.emrservice.examid);
  //     this.GetInvestigationDetailByRegId(this.opdvisitService.patientdetails.pkRegId);
  //   })
  // }
  GetInvestigationDetailByRegId(regid) {
    this.emrservice.GetInvestigationDetailByRegId(regid, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr).pipe(takeUntil(this.destroyinves$)).subscribe(
      data => this.success_allinvestigation(data), err => this.failed_allInvestigation(err)
    )
  }
  getinvetigationdata: any = [];
  success_allinvestigation(data) {
    this.getinvetigationdata = [];
    this.surgeryDetailArray = [];
    this.getinvetigationdata = data;
    if (this.getinvetigationdata.length > 0) {
      this.getinvetigationdata.forEach((element, index) => {
        this.surgeryDetailArray.push({
          "fK_TemplateId": 0, 'pK_TranId': element.pK_TranId, 'fK_ExamId': element.fK_ExamId, "pK_TempInvDetailId": 0, "serviceName": element.serviceName,
          "fK_ServiceId": element.fK_ServiceId, "rate": 0, "Site": element.eye, "Comments": element.result,
          "DisCount": element.discount, "isHidden": false, "isEdit": false, 'Academic': element.academic, "isDeleted": element.isDeleted, 'oldExamId': element.oldExamId
        });

        // 
      });
      this.surgeryDetailArray = this.surgeryDetailArray.filter(item => item.fK_ExamId == this.examid);

      this.investigation_ds = new MatTableDataSource(this.surgeryDetailArray.slice());

    } else {
      this.investigation_ds = new MatTableDataSource(this.emrservice.investigations.slice());
    }
  }
  failed_allInvestigation(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  newservice() {
    if (this.emrservice.investigationPermission.isAddPermission == true) {
        if (this.emrservice.visitid == null || this.emrservice.visitid == undefined) {
        this.dashboardService.openSnackBar("Please Select visit list", "OK");
      } else {
        if (this.loadTemplateModalIsOpen) {
          
          if(this.authService.Loggeduser.usertypeid == 9 || this.authService.Loggeduser.userid == this.InvestigationTemplateMasterModel.fKDoctorId){

            const dialogRef = this.dialog.open(InvestigationServicesComponent, {
              panelClass: 'full-width-dialog',
              maxWidth: '100vw !important',
              maxHeight: '90%',
              width: '80%',
            });
    
            dialogRef.afterClosed().pipe(takeUntil(this.destroyinves$)).subscribe(result => {
              this.emrservice.enabledisablebtnInv = false;
    
              var result = this.emrservice.selectedInvestigationRow.reduce((unique, o) => {
                if (!unique.some(obj => obj.serviceName === o.serviceName && obj.FK_ServiceId === o.FK_ServiceId)) {
                  unique.push(o);
                }
                return unique;
              }, []);
    
              if (result.length > 0) {
                result.forEach((element, index) => {
                  const isDuplicate = this.templatedetailData.some(
                    (item) => item.fK_ServiceId == element.serviceId
                  );
                  if (isDuplicate) {
                    this.dashboardService.openSnackBar("Service already exists in the selected template", "OK");
                    return;
                  }
              
                  this.templatedetailData.push({
                    "serviceName": element.serviceName,
                    "FK_ServiceId": element.serviceId,
                    "PK_TempInvDetailId": 0,
                    "FK_TemplateId":this.InvestigationTemplateMasterModel.pKTemplateId,
                    "rate":element.rate,
                    "discount":element.discount,
                    "isEdit": false,
                    "isHidden": false,
                  });
                });
                this.istransfershow = false
                this.isshowSave = true
              }
  
            });
          } else{
            this.dashboardService.openSnackBar("Permission Denied", "OK");
            return;
          }

        } else {
          const dialogRef = this.dialog.open(InvestigationServicesComponent, {
            panelClass: 'full-width-dialog',
            maxWidth: '100vw !important',
            maxHeight: '90%',
            width: '80%',
          });
  
          dialogRef.afterClosed().pipe(takeUntil(this.destroyinves$)).subscribe(result => {
            this.emrservice.enabledisablebtnInv = false;
            this.transferData(this.emrservice.selectedInvestigationRow)            
          });
        }
      }
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  
  
  // ondiscountPercentage(e: any, index: number) {

  //   if (e > 100) {
  //     this.surgeryDetailArray[index].DisCount = 0;
  //     this.dashboardService.openSnackBar("Discount Percent Not more than 100 ", "OK");
  //   }
  //   else if (e === null || e === undefined || e == "") {
  //     this.surgeryDetailArray[index].DisCount = 0;
  //     this.investigation_ds.data = this.surgeryDetailArray;
  //   }
  //   else {
  //     this.surgeryDetailArray[index].DisCount = e;
  //     this.investigation_ds.data = this.surgeryDetailArray;
  //   }
  //   this.emrservice.enabledisablebtnInv = false;
  // }
  onCommentchange(e: any, index: number) {

    if (e != null) {
      this.surgeryDetailArray[index].Comments = e;
      this.investigation_ds.data = this.surgeryDetailArray;

    }

  }
  enablebtn() {
    this.emrservice.enabledisablebtnInv = false;
  }
  deletesurgery(row: any) {
    if(Date.parse(this.datePipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid ==9) {
      if(this.authService.Loggeduser.usertypeid ==6){
        if(this.authService.Loggeduser.userid != this.opdvisitService.DoctorIdEmr){ 
           this.showspinner = false;    
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
    const index: number = this.surgeryDetailArray.indexOf(row);
    if (index !== -1) {
      if (row.pK_TranId == 0) {
        this.surgeryDetailArray.splice(index, 1);
        this.investigation_ds.data = this.surgeryDetailArray;
        if(this.investigation_ds.data.length ==0){
          this.emrservice.enabledisablebtnInv=true;
        }
      //  this.deleteInvesdata(row, 1);
      } else {
        if (this.emrservice.investigationPermission.isDeletePermission == true) {
          this.surgeryDetailArray.splice(index, 1);
          this.investigation_ds.data = this.surgeryDetailArray;
          this.deleteInvesdata(row, 1);
        } else {
          this.dashboardService.openSnackBar("Delete permission denied", "ok");
        }
      }

    }
  }else{
    this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "ok");
  }

  }
  onServiceChange(e: any, index: number) {
    if (e != null) {
      this.surgeryDetailArray[index].serviceName = e;
      this.investigation_ds.data = this.surgeryDetailArray;
    }
  }
  enableEditmode(e: any, index: number) {
    this.surgeryDetailArray[index].isEdit = true;
    this.investigation_ds.data = this.surgeryDetailArray;
    this.emrservice.enabledisablebtnInv = false;
  }
  onSitechange(e: any, index: number) {
    if (e != null) {
      this.surgeryDetailArray[index].Site = e;
      this.investigation_ds.data = this.surgeryDetailArray;
      this.emrservice.enabledisablebtnInv = false;
    }

  }
  setAll(e: any, index: number) {
    if (e == false) {
      this.surgeryDetailArray[index].Academic = true;
      this.investigation_ds.data = this.surgeryDetailArray;
    } else {
      this.surgeryDetailArray[index].Academic = false;
      this.investigation_ds.data = this.surgeryDetailArray;
    }
  }
  checkAlldata(event) {
    if (event == false) {
      if (this.surgeryDetailArray.length > 0) {
        for (var i = 0; i < this.surgeryDetailArray.length; i++) {
          this.surgeryDetailArray[i].Academic = true;
        }
        this.allcheck = true;
      }

    } else {
      if (this.surgeryDetailArray.length > 0) {
        for (var i = 0; i < this.surgeryDetailArray.length; i++) {
          this.surgeryDetailArray[i].Academic = false;
        }
        this.allcheck = false;
      }
    }

  }
  drInvestigationdata: any = [];
  SaveInvestigation(event,type:any) {
    if(Date.parse(this.datePipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid ==9) {
      if(this.authService.Loggeduser.usertypeid ==6){
        if(this.authService.Loggeduser.userid != this.opdvisitService.DoctorIdEmr){  
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
    
    if (this.emrservice.investigationPermission.isAddPermission == true) {
      if(type==0){
        const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
         button.setAttribute('disabled', true);
         this.showspinner = true;
      }
     
      this.drInvestigationdata = [];

      if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
        if (this.examid == null || this.examid == undefined) {
          this.examid = 0;
        }
        if (this.opdvisitService.patientdetails.pkRegId) {

          if (this.surgeryDetailArray.length > 0) {
           
            this.investigation_ds.data.forEach(item => {
              this.drInvestigationdata.push({
                "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
                "FK_ExamId": this.examid,
                "FK_ServiceId": item.fK_ServiceId,
                "Result": item.Comments,
                "Eye": item.Site,
                "Academic": item.Academic,
                "discount": item.DisCount ? item.DisCount : 0,
                "IsDeleted": 0,
                "IsEdit":item.pK_TranId > 0 ? true:false
              });
            });

            this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid;
            this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
            this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr;
            this.opdvisitService.patientDrdetaill[0].drFristDateTimeWorkupFinish = moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss");
            this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;
            let payload = {

              DrExam: {
                ...this.opdvisitService.patientDrdetaill[0]

              },

              DrFinding: []
              ,
              DrDiag: [
              ],
              DrPrescrip: [
              ],
              DrInvest: this.drInvestigationdata
              , DrSurgery: [
              ]
            }
            try {
              this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroyinves$)).subscribe(data => {
                if (data['statusCode'] == 1) {
                  if (this.examid > 0) {
                    this.emrservice.savedrWorkupTrackingSatus('Modify Doctor Workup', 'true', 'DR');
                  } else {
                    this.emrservice.savedrWorkupTrackingSatus('Doctor Workup', 'false', 'DR');
                  }
                  this.showspinner = false;
                  this.examid = data['id'];
                  this.emrservice.examid = data['id'];
                  //this.emrservice.content.next('2');
                  this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr, 1);
                  this.GetInvestigationDetailByRegId(this.opdvisitService.patientdetails.pkRegId);
                  this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0);
                  this.emrservice.enabledisablebtnInv = true;
                  this.dashboardService.openSnackBar("Record Saved Successfully", "OK");

                }else if(data['statusCode'] == 10) {
                  this.showspinner = false;
                  this.dashboardService.openSnackBar("Already exists in the list", "OK");
                } else {
                  this.showspinner = false;
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              },
                err => {
                  this.showspinner = false;
                  if (err.status == 403) {
                    this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                  } 
                  else if(err.error.statusCode == 422){
                    this.dashboardService.openSnackBar(err.error.message,"OK");
                  }
                  else {
                    this.dashboardService.openSnackBar("API Failed", "OK");
                  }
                  // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");

                });
            }
            catch (error) {
              this.showspinner = false;
            }
          } else {
            this.dashboardService.openSnackBar("Please Add Investigation", "OK");
          }
        } else {
          this.dashboardService.openSnackBar("Please Select Patient", "OK");
        }

      } else {
        this.dashboardService.openSnackBar("Please Select Visit List", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }else{
    this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
  }
  }
  Cancelpopup(type) {

    if (type == 1) {
      if (this.emrservice.investigationPermission.isDeletePermission == true) {
        document.getElementById("investigationModal").style.display = "Block";
      } else {
        this.dashboardService.openSnackBar("Delete Permission Denied", "OK");
      }

    } else {
      document.getElementById("investigationModal").style.display = "None";
    }

  }
  deleterinvarray: any = [];
  deleteInvesdata(rowdata, type) {
    if(Date.parse(this.datePipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.emrservice.visitDate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid ==9) {
      if(this.authService.Loggeduser.usertypeid ==6){
        if(this.authService.Loggeduser.userid != this.opdvisitService.DoctorIdEmr){  
          return this.dashboardService.openSnackBar("⁠You can not modify another's Dr workup.", "OK");
        }
      }
    if (type == 1) {
      if (rowdata.pK_TranId > 0) {
        this.deleterinvarray.push({
          "PK_TranId": rowdata.pK_TranId,
          "FK_ExamId": rowdata.fK_ExamId,
          "FK_ServiceId": rowdata.fK_ServiceId,
          "Result": rowdata.Comments,
          "discount": rowdata.DisCount,
          "Eye": rowdata.Site,
          "Academic": rowdata.Academic,
          "IsEdit":rowdata.pK_TranId >0 ? true:false,
          "IsDeleted": 1
        });
      }

    } else {
      rowdata?.forEach(item => {
        if (item.pK_TranId > 0) {
          this.deleterinvarray.push({
            "PK_TranId": item.pK_TranId,
            "FK_ExamId": item.fK_ExamId,
            "FK_ServiceId": item.fK_ServiceId,
            "Result": item.Comments,
            "discount": rowdata.DisCount,
            "Eye": item.Site,
            "Academic": item.Academic,
            "IsEdit":item.pK_TranId >0 ? true:false,
            "IsDeleted": 1
          });
        }

      });
    }
    if (this.deleterinvarray.length > 0) {
      this.opdvisitService.patientDrdetaill[0].pK_ExamId = this.examid;
      this.opdvisitService.patientDrdetaill[0].fK_VisitId = this.emrservice.visitid;
      this.opdvisitService.patientDrdetaill[0].fK_DoctorId = this.opdvisitService.DoctorIdEmr
      this.opdvisitService.patientDrdetaill[0].isEdit = this.examid > 0 ? true : false;
      let payload = {

        DrExam: {
          ...this.opdvisitService.patientDrdetaill[0]

        },

        DrFinding: []
        ,
        DrDiag: [
        ],
        DrPrescrip: [
        ],
        DrInvest: this.deleterinvarray
        , DrSurgery: []
      }
      this.emrservice.SaveDrwrokupData(payload).pipe(takeUntil(this.destroyinves$)).subscribe(data => {
        this.showspinner = false;
        if (data['statusCode'] == 1) {

          this.deleterinvarray = [];
          // this.GetFindingGResultByregid(this.opdvisitService.patientdetails.pkRegId);
          this.GetInvestigationDetailByRegId(this.opdvisitService.patientdetails.pkRegId);
          this.emrservice.drWorkupExamStatus(this.emrservice.visitid, this.emrservice.examid != null ? this.emrservice.examid : 0);
          this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
          document.getElementById("investigationModal").style.display = "None";
          if (type == 2) {
            this.surgeryDetailArray = [];

          }
          if (this.surgeryDetailArray.length == 0) {
            this.investigation_ds = new MatTableDataSource(this.emrservice.investigations.slice());
          }
        }else if(data['statusCode'] == 10) {
          this.dashboardService.openSnackBar("Already exists in the list", "OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      },
        err => {
          this.showspinner = false;
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
          // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");

        });
    } else {
      if (type == 2) {
        this.surgeryDetailArray = [];

      }
      if (this.surgeryDetailArray.length == 0) {
        this.investigation_ds = new MatTableDataSource(this.emrservice.investigations.slice());
      }
      this.showspinner = false;
      this.emrservice.enabledisablebtnInv = true;
      this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
      document.getElementById("investigationModal").style.display = "None";
    }
  }else{
    this.dashboardService.openSnackBar("You don't have permission to modify back date visit", "OK");
  }
  }
  closedialog() {
    this.dialogRef.close();
  }

  openpreviousinvestigationModal(): void {
    this.inhou_Investigation()
  }

  cancelpreviousinvestigationModal(): void {
    document.getElementById("previousinvestigationModal").style.display = "none";
  }

  inhou_Investigation() {
    this.emrservice
      .getProcedureData(this.opdvisitService.patientdetails.pkRegId)
      .pipe(takeUntil(this.destroyinves$))
      .subscribe((data:any[]) => {
        this.inhouse_data = data.sort((a, b) => new Date(b.procedureDate).getTime() - new Date(a.procedureDate).getTime());
        
        if (this.inhouse_data && this.inhouse_data.length > 0) {
          document.getElementById("previousinvestigationModal").style.display = "block";
        } else {
          this.dashboardService.openSnackBar("No past investigation found for this patient", "OK");
        }
      },err =>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }

  openLoadTemplateModal() {
    document.getElementById("loadTemplateModal").style.display = "block";
    this.getTemplates(0,this.authService.Loggeduser.userid)
    this.loadTemplateModalIsOpen = true
  }

  closeLoadTemplateModal() {
    document.getElementById("loadTemplateModal").style.display = "none";
    this.loadTemplateModalIsOpen = false
  }
  opensearchtemplateModal(type:any) {
  if(type == 0 ){
    this.InvestigationTemplateMasterModel={}
    document.getElementById("searchtemplateModal").style.display = "block"; 
    this.doctorControll1();
    setTimeout(() => {
      if (this.authService.Loggeduser.usertypeid == 6) {
        this.InvestigationTemplateMasterModel.uName = this.authService.Loggeduser.firstname;
        this.doctorID = this.authService.Loggeduser.userid;
        this.InvestigationTemplateMasterModel.fKDoctorId = this.authService.Loggeduser.userid;
      }
    }, 1000);
  }else{
    document.getElementById("searchtemplateModal").style.display = "block"; 
  }
   
  }
  closesearchtemplateModal() {
    document.getElementById("searchtemplateModal").style.display = "none";
    this.getTemplates(0,this.authService.Loggeduser.userid)
  }
holtemplateArray:any[] =[]
  getTemplates(templateId: number , userId: number) {
    this.emrservice.GETOPDDrInvestigationTemplateMaster(0 , userId).pipe(takeUntil(this.destroyinves$)).subscribe((data: any[]) => {
        this.findingTemplateArray = [];
        this.holtemplateArray=[]
        if (data && data.length > 0) {
          this.findingTemplateArray = data;
          this.holtemplateArray = data
          const firstTemplateId = data[0]?.pK_TemplateId;
          this.rowClickedtemplate = data[0].pK_TemplateId;
          const firstTemplate = data[0];
          this.InvestigationTemplateMasterModel = {
            pKTemplateId: firstTemplate.pK_TemplateId,
            tName: firstTemplate.templateName,
            fKDoctorId: firstTemplate.fK_DoctorId,
            tType: firstTemplate.templateType,
            isActive:firstTemplate.isActive
        };         
         this.getTemplatesDetail(firstTemplateId); 
        }
          
   },err =>{
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
   });
  }




  specificFinding(row) {
    this.InvestigationTemplateMasterModel={};
    this.InvestigationTemplateMasterModel.uName = row.userName
    this.InvestigationTemplateMasterModel.tName = row.templateName
    this.InvestigationTemplateMasterModel.pKTemplateId = row.pK_TemplateId
    this.InvestigationTemplateMasterModel.fKDoctorId = row.fK_DoctorId
    this.InvestigationTemplateMasterModel.isActive = row.isActive
    this.InvestigationTemplateMasterModel.isEdit = row.isEdit
    this.InvestigationTemplateMasterModel.tType = row.templateType
    this.rowClickedtemplate = row.pK_TemplateId;
    this.getTemplatesDetail(row.pK_TemplateId);
  }
  getTemplatesDetail(templateId: any) {
    this.templatedetailData=[]
    this.emrservice.GETOPDDrInvestigationTemplateDetailByTemplateId(templateId).pipe(takeUntil(this.destroyinves$)).subscribe((data: any[]) => {
      if (data && data.length > 0) {
       this.templatedetailData = data;
       this.templatedetailData.map(item => item.isEdit = true);
       this.templatedetailData.map(item => item.IsHidden = false);
      }
   },err =>{
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
   });
  }

  insertUpdateInvestigationTemplate(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
     if(!this.InvestigationTemplateMasterModel.pKTemplateId || this.InvestigationTemplateMasterModel.pKTemplateId  == 0){
      const existingTemplate = this.holtemplateArray.filter(template =>
        template.templateName.toLowerCase() == this.InvestigationTemplateMasterModel.tName.toLowerCase() 
        && this.InvestigationTemplateMasterModel.fKDoctorId == template.fK_DoctorId );
       if (existingTemplate.length > 0) {
        this.dashboardService.openSnackBar("Already exists in the list", "OK");
        this.InvestigationTemplateMasterModel ={}
        return;
       }
      const payload = {
        "InsertOPDInvtemplatemasterDto": {
          "PK_TemplateId":this.InvestigationTemplateMasterModel.pKTemplateId ? this.InvestigationTemplateMasterModel.pKTemplateId : 0,
          "TemplateName": this.InvestigationTemplateMasterModel.tName,
          "FK_DoctorId": this.InvestigationTemplateMasterModel.fKDoctorId || null,
          "IsEdit":false,
          "TemplateType": this.InvestigationTemplateMasterModel.tType,
          "IsActive": this.InvestigationTemplateMasterModel.isActive ? this.InvestigationTemplateMasterModel.isActive : false,
          "IsDelete": false
        },
        "InsertTemplateOPDInvestigationDetailDto": [] 
      };

      this.emrservice.InsertOPDDrInvestigationTemplateMaster(payload).pipe(
        takeUntil(this.destroyinves$)
      ).subscribe(
        response => {
          this.dashboardService.openSnackBar("Record saved successfully", "OK");
          this.InvestigationTemplateMasterModel.tName =''
          this.InvestigationTemplateMasterModel.isActive = false;
          this.closesearchtemplateModal();
          this.getTemplates(0,this.authService.Loggeduser.userid)
        },
        err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
          // this.dashboardService.openSnackBar("Failed to save template", "OK");
        }
      );
     }else{
      const payload = {
        "InsertOPDInvtemplatemasterDto": {
          "PK_TemplateId":this.InvestigationTemplateMasterModel.pKTemplateId ,
          "TemplateName": this.InvestigationTemplateMasterModel.tName,
          "FK_DoctorId": this.InvestigationTemplateMasterModel.fKDoctorId || null ,
          "IsEdit": true,
          "TemplateType": this.InvestigationTemplateMasterModel.tType,
          "IsActive": this.InvestigationTemplateMasterModel.isActive ? this.InvestigationTemplateMasterModel.isActive : false,
          "IsDelete": false
        },
        "InsertTemplateOPDInvestigationDetailDto": [] 
      };

      this.emrservice.InsertOPDDrInvestigationTemplateMaster(payload).pipe(
        takeUntil(this.destroyinves$)
      ).subscribe(
        (response:any) => {
          if (response.statusCode == 1) { 
            this.dashboardService.openSnackBar("Record updated successfully", "OK");
            this.InvestigationTemplateMasterModel.tName = '';
            this.InvestigationTemplateMasterModel.isActive = false;
            this.closesearchtemplateModal();
            this.getTemplates(0, this.authService.Loggeduser.userid);
          }
           else if (response.statusCode == 10) { 
            this.dashboardService.openSnackBar("Already exists in the list", "OK");
            this.InvestigationTemplateMasterModel ={}
            return;         
           }
           else if (response.statusCode == 7) {
            this.dashboardService.openSnackBar("Edit permission is not allowed", "OK");
            this.closesearchtemplateModal();
            this.getTemplates(0, this.authService.Loggeduser.userid);
            return;
          }
        },
        err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
          }
      );
     }
  }
  
  doctorControll1() {
    this.doctorholdData = of(this.opdvisitService.doctors);
    this.DoctorCtrl1 = new FormControl();
    this.filteredDoctorArray1 = this.DoctorCtrl1.valueChanges
      .pipe(startWith(''),
        switchMap(value => this._filter(value))
      ); 
  }
  checkdocid(event: any) {
    if (event.target.value == "") {
      this.InvestigationTemplateMasterModel.uName = null;
      this.InvestigationTemplateMasterModel.fKDoctorId = null;
    }
  }

  getdoctorobj1(e: any) {
    var val = e.option.value;
    this.InvestigationTemplateMasterModel.uName = val.userName;
    this.InvestigationTemplateMasterModel.fKDoctorId = val.userId;
  }

  private _filter(value:any): Observable<string[]> {
    // const searchvalue = value.toLowerCase()
    // return this.doctorholdData.pipe(
    //   map(options => options.filter(option => option.userName.toLowerCase().includes(searchvalue)))
    // )
    let searchValue = '';
    if (typeof value === 'string') {
      searchValue = value.toLowerCase();
    } else if (value && typeof value === 'object' && value.userName) {
      searchValue = value.userName.toLowerCase();
    }
  
    return this.doctorholdData.pipe(
      map(options =>
        options.filter(option =>
          option.userName.toLowerCase().includes(searchValue)
        )
      )
    );
  }

  editTemplate(row){
  
    if(this.authService.Loggeduser.usertypeid == 9 || this.authService.Loggeduser.userid == row.fK_DoctorId){
      this.InvestigationTemplateMasterModel.isEdit=true;
      this.InvestigationTemplateMasterModel.isActive =row.isActive;
      this.InvestigationTemplateMasterModel.uName =row.userName;
      this.InvestigationTemplateMasterModel.fKDoctorId =row.fK_DoctorId;
      this.InvestigationTemplateMasterModel.pKTemplateId =row.pK_TemplateId;
      this.InvestigationTemplateMasterModel.tName=row.templateName;
      this.InvestigationTemplateMasterModel.tType =row.templateType;
      setTimeout(() => {
        document.getElementById("searchtemplateModal").style.display = "block"; 
      }, 300)
    }else{
      this.dashboardService.openSnackBar("Permission Denied" , "OK")
    }
  }


  sortdata(){
    const sortdata = this.findingTemplateArray.sort(this.compareValues('templateName'));
    this.InvestigationTemplateMasterModel = sortdata[0];
    this.rowClickedtemplate = sortdata[0].pK_TemplateId;
    this.getTemplatesDetail(sortdata[0].pK_TemplateId);
    this.findingTemplateArray = [];
    this.findingTemplateArray.push(...sortdata);
  }
  sortdatadesc() {
    const sortdataa = this.findingTemplateArray.sort(this.compareValues('templateName', 'desc'));
    this.InvestigationTemplateMasterModel = sortdataa[0];
    this.rowClickedtemplate = sortdataa[0].pK_TemplateId;
    this.getTemplatesDetail(sortdataa[0].pK_TemplateId);
    this.findingTemplateArray = [];
    this.findingTemplateArray.push(...sortdataa);
  }

  sortdatadr() {
    const sortdata = this.findingTemplateArray.sort(this.compareValues('userName'));
    this.InvestigationTemplateMasterModel = sortdata[0];
    this.rowClickedtemplate = sortdata[0].pK_TemplateId;
    this.getTemplatesDetail(sortdata[0].pK_TemplateId);
    this.findingTemplateArray = [];
    this.findingTemplateArray.push(...sortdata);
  }
  sortdatadescdr() {
    const sortdataa = this.findingTemplateArray.sort(this.compareValues('userName', 'desc'));
    this.InvestigationTemplateMasterModel = sortdataa[0];
    this.rowClickedtemplate = sortdataa[0].pK_TemplateId;
    this.getTemplatesDetail(sortdataa[0].pK_TemplateId);
    this.findingTemplateArray = [];
    this.findingTemplateArray.push(...sortdataa);
  }

  compareValues(key, order = 'asc') {

    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0;
      }

      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  insertupdatedetailtemplate(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    const payload = {
      "InsertOPDInvtemplatemasterDto": {
        "PK_TemplateId": this.InvestigationTemplateMasterModel.pKTemplateId ? this.InvestigationTemplateMasterModel.pKTemplateId : 0,
        "TemplateName": this.InvestigationTemplateMasterModel.tName,
        "FK_DoctorId": this.InvestigationTemplateMasterModel.fKDoctorId,
        "IsEdit": this.InvestigationTemplateMasterModel.pKTemplateId > 0 ? true : false,
        "TemplateType": this.InvestigationTemplateMasterModel.tType,
        "IsActive": this.InvestigationTemplateMasterModel.isActive ? this.InvestigationTemplateMasterModel.isActive : false,
        "IsDelete": false
      },
      "InsertTemplateOPDInvestigationDetailDto": this.templatedetailData.concat(this.getdeletetemplateInvestigation)
    };
  
    this.emrservice.InsertOPDDrInvestigationTemplateMaster(payload).pipe(
      takeUntil(this.destroyinves$)
    ).subscribe(
      (response: any)  => {
        if (response.statusCode == 1) {
          this.dashboardService.openSnackBar("Record saved successfully", "OK");
          this.getTemplatesDetail(response['id']);
          this.getdeletetemplateInvestigation = [];
          this.istransfershow = true;
          this.isshowSave = false
        } 
        else if (response.statusCode == 7){
          this.dashboardService.openSnackBar("Permission denied", "OK");
          this.getTemplatesDetail(this.InvestigationTemplateMasterModel.pKTemplateId);
          this.isshowSave = false
          return
        }
      },
      (err) => {
      if (err.status == 401 || err.status == 429) {
          this.dashboardService.openSnackBar(err.error, "OK");
          this.isshowSave = false
        }else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }else if(err.status == 403){
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else  {
          this.dashboardService.openSnackBar("API FAILED", "OK");
          this.isshowSave = false
        }
      }
    );
  }
  

getdeletetemplateInvestigation :InvestigationTemplatedataModel[]=[]
  removeExam(row , index: number) {
    if(this.authService.Loggeduser.usertypeid == 9 || this.authService.Loggeduser.userid == this.InvestigationTemplateMasterModel.fKDoctorId){
      this.templatedetailData.splice(index, 1);
      if(row.pK_TempInvDetailId  > 0){
        this.getdeletetemplateInvestigation.push(row);
        this.getdeletetemplateInvestigation.map(item => item.isEdit = true);
        this.getdeletetemplateInvestigation.map(item => item.IsHidden = true);
      }
      this.isshowSave = true
    }else{
      this.dashboardService.openSnackBar("Permission denied", "OK");
    }
  }
  removeTemplate(row, index: number) {
    this.InvestigationTemplateMasterModel={};
    this.InvestigationTemplateMasterModel.uName = row.userName
    this.InvestigationTemplateMasterModel.tName = row.templateName
    this.InvestigationTemplateMasterModel.pKTemplateId = row.pK_TemplateId
    this.InvestigationTemplateMasterModel.fKDoctorId = row.fK_DoctorId
    this.InvestigationTemplateMasterModel.isActive = row.isActive
    this.InvestigationTemplateMasterModel.isEdit = row.isEdit
    this.InvestigationTemplateMasterModel.tType = row.templateType
    this.doctorControll1()
    this.rowClickedtemplate = row.pK_TemplateId;
    this.getTemplatesDetail(row.pK_TemplateId);
    const payload = {
      "InsertOPDInvtemplatemasterDto": {
        "PK_TemplateId": this.InvestigationTemplateMasterModel.pKTemplateId?this.InvestigationTemplateMasterModel.pKTemplateId:0,
        "TemplateName": this.InvestigationTemplateMasterModel.tName,
        "FK_DoctorId": this.InvestigationTemplateMasterModel.fKDoctorId,
        "IsEdit": this.InvestigationTemplateMasterModel.pKTemplateId > 0,
        "TemplateType": this.InvestigationTemplateMasterModel.tType,
        "IsDelete": true,
        "IsActive": this.InvestigationTemplateMasterModel.isActive,
      },
      "InsertTemplateOPDInvestigationDetailDto": []
    };
  
    this.emrservice.InsertOPDDrInvestigationTemplateMaster(payload)
      .pipe(takeUntil(this.destroyinves$))
      .subscribe(
        (response: any) => {
          if (response.statusCode == 1) {
            this.dashboardService.openSnackBar("Record deleted successfully", "OK");
            this.getTemplates(0, this.authService.Loggeduser.userid);
          } else if (response.statusCode == 7) {
            this.dashboardService.openSnackBar("Permission Denied", "OK");
          } else {
            this.dashboardService.openSnackBar("API FAILED", "OK");
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  
  transferFIndingdata(templatedetailData){
    this.transferData(templatedetailData)
    this.loadTemplateModalIsOpen= false;
    this.closeLoadTemplateModal();
    this.emrservice.enabledisablebtnInv = false;
  }

  transferData(transferArray:any){
      var result = transferArray.reduce((unique, o) => {
      if (!unique.some(obj => obj.serviceName === o.serviceName && obj.FK_ServiceId === o.FK_ServiceId)) {
        unique.push(o);
      }
      return unique;
    }, []);

    if (result.length > 0) {
      result.forEach((element, index) => {
        this.surgeryDetailArray.push({
          "fK_TemplateId": 0, 'pK_TranId': 0, 'fK_ExamId': 0, "pK_TempInvDetailId": 0, 
          "serviceName": element.serviceName, "fK_ServiceId": element.serviceId || element.fK_ServiceId, "rate": element.rate, 
          "Site": '', "Comments": '', "DisCount": element.discount, "isHidden": false, "isEdit": false, 
          'Academic': false, "isDeleted": 0, 'oldExamId': null
        });
      });

      this.surgeryDetailArray = this.surgeryDetailArray.reduce((unique, o) => {
        if (!unique.some(obj => obj.serviceName === o.serviceName && obj.fK_ServiceId === o.fK_ServiceId)) {
          unique.push(o);
        }
        return unique;
      }, []);

      const index = this.surgeryDetailArray.filter(list => list.fK_ServiceId == 0);
      if (index.length > 0) {
        this.surgeryDetailArray.splice(index, 1);
      }

      this.investigation_ds = new MatTableDataSource(this.surgeryDetailArray.slice());
  }
}
isAdminUser() {
  return this.authService.Loggeduser.usertypeid == 9; 
}
}

